document.addEventListener('DOMContentLoaded', () => {
  const reveal = [...document.querySelectorAll('[data-reveal], .reveal-on-scroll, .bento-card, .contact-card, .about-us-container, .video-track-wrapper, .product-card, .trust-features-wrapper')];
  const observer = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      }
    });
  }, {threshold:.12, rootMargin:'0px 0px -40px'});
  reveal.forEach((el,i)=>{ el.style.transitionDelay = `${Math.min(i%6,5)*70}ms`; observer.observe(el); });

  const header=document.querySelector('.site-header');
  const headerScroll=()=>header?.classList.toggle('scrolled',window.scrollY>18);
  headerScroll(); window.addEventListener('scroll',headerScroll,{passive:true});

  const openMenu=document.querySelector('.mobile-menu-toggle'), drawer=document.querySelector('.mobile-drawer'), closeMenu=document.querySelector('.mobile-drawer-close');
  const setMenu=(open)=>{drawer?.classList.toggle('active',open);document.body.classList.toggle('menu-open',open)};
  openMenu?.addEventListener('click',()=>setMenu(true)); closeMenu?.addEventListener('click',()=>setMenu(false));
  drawer?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));

  window.adjustQty=(amount)=>{
    const input=document.getElementById('Quantity'); if(!input)return;
    input.value=Math.max(1,(parseInt(input.value)||1)+amount); input.dispatchEvent(new Event('change',{bubbles:true}));
  };
  window.switchMainImage=(url,btn)=>{
    const img=document.getElementById('ProductMainImage'); if(img)img.src=url;
    document.querySelectorAll('.thumbnail-btn').forEach(b=>b.classList.remove('active')); btn?.classList.add('active');
  };
  window.handleBuyNow=()=>{
    const select=document.querySelector('.product-single-select'), qty=document.getElementById('Quantity');
    if(select?.value) window.location.href=`/cart/${select.value}:${Math.max(1,parseInt(qty?.value)||1)}?checkout`;
  };

  const variants = window.Shopify && false ? [] : null;
  const form=document.getElementById('AddToCartForm');
  if(form){
    const dataEl=form.querySelector('[data-product-json]');
    let productData=null; try{productData=dataEl?JSON.parse(dataEl.textContent):null}catch(e){}
    const options=[...form.querySelectorAll('.single-option-selector')], master=form.querySelector('.product-single-select');
    const price=document.getElementById('ProductPrice'), compare=document.getElementById('ComparePrice'), badge=document.getElementById('DiscountBadge');
    const updateVariant=()=>{
      if(!productData?.variants?.length)return;
      const selected=options.map(o=>o.value);
      const v=productData.variants.find(x=>x.options.every((o,i)=>o===selected[i]));
      if(!v)return; if(master)master.value=v.id;
      if(price && v.price)price.textContent=new Intl.NumberFormat('en-IN',{style:'currency',currency:window.Shopify?.currency?.active||'INR'}).format(v.price/100);
      if(compare){compare.textContent=v.compare_at_price>v.price?new Intl.NumberFormat('en-IN',{style:'currency',currency:window.Shopify?.currency?.active||'INR'}).format(v.compare_at_price/100):'';compare.style.display=v.compare_at_price>v.price?'inline':'none'}
      if(badge){badge.textContent=v.compare_at_price>v.price?`${Math.round((v.compare_at_price-v.price)*100/v.compare_at_price)}% OFF`:'';badge.style.display=v.compare_at_price>v.price?'inline':'none'}
      const add=document.getElementById('AddToCart'), buy=document.getElementById('BuyNowBtn'), text=document.getElementById('AddToCartText');
      [add,buy].forEach(b=>{if(b)b.disabled=!v.available}); if(text)text.textContent=v.available?'Add to Cart':'Sold Out';
    };
    options.forEach(o=>o.addEventListener('change',updateVariant)); updateVariant();
  }

  document.querySelectorAll('[data-ba]').forEach(section=>{
    const range=section.querySelector('.ba-range'), layer=section.querySelector('.ba-layer'), handle=section.querySelector('.ba-handle');
    if(!range||!layer||!handle)return;
    const set=(value)=>{layer.style.width=`${value}%`;handle.style.left=`${value}%`};
    range.addEventListener('input',e=>set(e.target.value)); set(50);
  });

  document.querySelectorAll('[data-count]').forEach(el=>{
    const target=parseInt(el.dataset.count,10)||0, suffix=el.dataset.suffix||'';
    const obs=new IntersectionObserver(entries=>{
      entries.forEach(en=>{
        if(!en.isIntersecting)return;
        let start=0, duration=1300, t0=null;
        const step=t=>{if(!t0)t0=t;const p=Math.min((t-t0)/duration,1), eased=1-Math.pow(1-p,3);el.textContent=Math.round(target*eased).toLocaleString('en-IN')+suffix;if(p<1)requestAnimationFrame(step)};
        requestAnimationFrame(step);obs.unobserve(el);
      })
    },{threshold:.7});obs.observe(el);
  });

  document.querySelectorAll('[data-video-modal]').forEach(card=>{
    card.addEventListener('click',()=>{
      const modal=document.querySelector('.video-modal'), video=modal?.querySelector('video');
      if(!modal||!video)return;
      const source=card.querySelector('video source')?.src||card.querySelector('video')?.currentSrc;
      if(source){video.src=source;video.load();} modal.classList.add('active'); video.play().catch(()=>{});
    });
  });
  document.querySelector('.video-modal-close')?.addEventListener('click',()=>{
    const m=document.querySelector('.video-modal'),v=m?.querySelector('video');v?.pause();m?.classList.remove('active');
  });
  document.querySelector('.video-modal')?.addEventListener('click',e=>{if(e.target.classList.contains('video-modal'))document.querySelector('.video-modal-close')?.click()});
});
